import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import WorkOrderActivity from 'components/work-order/shared/WorkOrderActivity'

const FILTER_MODEL_STORAGE_KEY = 'WO_LIST_ITEM_ACTIVITY_FILTER_MODEL'

const WorkOrderActivityTab = ({ workOrderId, configuredServiceId, configuredServiceEventId, configuredServiceEventType }) => {
  return (
    <Box p={2}>
      <WorkOrderActivity
        workOrderId={workOrderId}
        configuredServiceId={configuredServiceId}
        configuredServiceEventId={configuredServiceEventId}
        configuredServiceEventType={configuredServiceEventType}
        filterModelStorageKey={FILTER_MODEL_STORAGE_KEY}
        maxHeight={400}
      />
    </Box>
  )
}

WorkOrderActivityTab.propTypes = {
  configuredServiceId: PropTypes.string,
  configuredServiceEventType: PropTypes.string,
  configuredServiceEventId: PropTypes.string,
  workOrderId: PropTypes.string,
}

export default WorkOrderActivityTab
